import { SectionHeading } from "../components/SectionHeading";
import { organization } from "../content";

export function HomePage() {
  return (
    <main id="top">
      <section className="page-hero" aria-labelledby="hero-title">
        <div className="content-width">
          <div className="hero-copy">
            <p className="hero-organization">{organization.nameJa}</p>
            <p className="hero-english-name">{organization.nameEn}</p>
            <h1 id="hero-title">
              年齢ではなく、
              <br />
              <span>能力で機会を。</span>
            </h1>
            <p className="hero-lead">
              高度なスキルを持つ若者が、互いに競い、学び、社会とつながるコミュニティ。
            </p>
          </div>
        </div>
      </section>

      <div className="notice-bar" id="information" aria-label="お知らせ">
        <div className="content-width notice-inner">
          <span className="notice-label">INFORMATION</span>
          <p>AIYSSは現在、スポンサー企業との連携に向けた準備を進めています。</p>
          <a href="/sponsors/">
            スポンサー企業の方へ <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>

      <section
        className="content-section"
        id="about"
        aria-labelledby="about-title"
      >
        <div className="content-width section-layout">
          <SectionHeading index="ABOUT" title="AIYSSとは" id="about-title" />
          <div className="section-body">
            <p className="section-lead">
              才能を、孤立させない。
              <br />
              実力を、次の接点へ。
            </p>
            <p>
              日本には、正社員として働くプログラマーと同等以上のスキルを持つ中高生が、一定数存在します。
              しかし彼らは、年齢を理由に、プログラマーとして働くことが困難です。代わりに、コンビニや飲食店で、アルバイトをしています。
              この現状が社会の損失であると、私たちは考えています。
            </p>
            <p>
              AIYSS(青少年科学者社会接続推進協会)は、十分な技術力を持つ中高生に、そのスキルを活かした仕事に就ける環境を整備します。
              18歳未満が技術職に就きたいと思った場合、選択肢の多くは、起業になります。
              起業には興味がないが、早いうちから、技術者として働きたい、そんな中高生の希望を叶えたいです。
            </p>
            <p>
              そして、高いスキルを持つ学生は、社会で孤立してしまう事も少なくありません。
              学校では、話の合う友達が作りにくいからです。
              普通の市立小中学校で、大学レベルの数学やプログラミングができる、一般的にギフテッドと呼ばれる子が、クラスメイトと好きなものの話で楽しめるでしょうか？
              優秀過ぎるが故に、周囲から浮いてしまう学生が、ありのままの自分でいられる場所を、私たちは作ります。
            </p>
            <p>
              学年や住む場所に関係なく、科学に強い興味がある学生同士が、楽しく交流できるコミュニティです。
              科学オリンピック、Kaggle・プロコン・ロボコン・CTF・競技プログラミング・競技数学、得意分野を問わず歓迎します。
              あなたたちとつながれる日を、楽しみにお待ちしております。
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
